module.exports = __webpack_public_path__ + "3e8039242e517ee7edc05a4e226e0b80.gif";